/**
 * Display order for daily and weekly report tables: latest period first.
 *
 * API payloads stay oldest-first (and CSV column order is unchanged). Equal
 * period keys keep their original relative order so same-day channel rows
 * stay in the order the report returned.
 */
export function newestPeriodFirst<T>(rows: readonly T[], periodKey: (row: T) => string): T[] {
  return [...rows].sort((left, right) => {
    const leftKey = periodKey(left);
    const rightKey = periodKey(right);
    if (leftKey === rightKey) {
      return 0;
    }
    return leftKey < rightKey ? 1 : -1;
  });
}
